var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoFramePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37484 1.6665C8.23635 1.66761 7.27581 1.67496 6.45817 1.72359V5.20797H9.37484V1.6665Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20817 1.851C4.18923 2.01289 3.45692 2.31667 2.88689 2.88669C2.31686 3.45672 2.01309 4.18903 1.8512 5.20797H5.20817V1.851Z",
    fill: "#5A5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 9.99964C1.6665 8.5826 1.6665 7.42114 1.72378 6.45797L18.2759 6.45797C18.3332 7.42114 18.3332 8.5826 18.3332 9.99964C18.3332 11.4167 18.3332 12.5781 18.2759 13.5413L1.72378 13.5413C1.6665 12.5781 1.6665 11.4167 1.6665 9.99964ZM10.3425 8.67012C11.2252 9.26338 11.6665 9.56 11.6665 9.99984C11.6665 10.4397 11.2252 10.7363 10.3425 11.3295C9.44775 11.9309 9.00037 12.2316 8.66677 12.0108C8.33317 11.7901 8.33317 11.1933 8.33317 9.99984C8.33317 8.80636 8.33317 8.20962 8.66677 7.98886C9.00037 7.76809 9.44774 8.06876 10.3425 8.67012Z",
    fill: "#5A5A5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1485 5.20797C17.9866 4.18903 17.6828 3.45672 17.1128 2.8867C16.5428 2.31667 15.8104 2.01289 14.7915 1.85101V5.20797H18.1485Z",
    fill: "#5A5A5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6248 1.6665C11.7633 1.66761 12.7239 1.67496 13.5415 1.72359V5.20797H10.6248V1.6665Z",
    fill: "#5A5A5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1485 14.7913H14.7915V18.1483C15.8104 17.9864 16.5428 17.6826 17.1128 17.1126C17.6828 16.5426 17.9866 15.8103 18.1485 14.7913Z",
    fill: "#5A5A5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5415 14.7913V18.2757C12.7239 18.3243 11.7633 18.3317 10.6248 18.3328V14.7913H13.5415Z",
    fill: "#5A5A5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37484 18.3328V14.7913H6.45817L6.45817 18.2757C7.27581 18.3243 8.23635 18.3317 9.37484 18.3328Z",
    fill: "#5A5A5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20817 14.7913L5.20817 18.1483C4.18923 17.9864 3.45692 17.6826 2.88689 17.1126C2.31686 16.5426 2.01309 15.8103 1.8512 14.7913H5.20817Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFramePlay);
export default __webpack_public_path__ + "static/media/videoFramePlay.0ac088bdbdb0a4e21116ff412381b3d6.svg";
export { ForwardRef as ReactComponent };